import * as actionTypes from '../actionTypes';
import { moduleTypes } from '../../util/constants';
import { getAxiosInstance } from '../../util/service';

/**
 * Review Inbox Action (v2)
 *
 * Changes:
 *  - Removed getCompanyId() → resolved from getState()
 *  - Reduced duplicated dispatch logic
 *  - Consistent error handling
 */

export const getReviewLocationList = (location, isListView) => {
    return async (dispatch, getState) => {
        const { authInfo } = getState();
        const companyId = authInfo.companyId || '';
        const url = `dashboard/reviewInvoice?companyId=${companyId}&reviewLocation=${location || null}&isListView=${isListView}`;

        const type = isListView ? actionTypes.GET_REVIEW_INVOICE_LIST : actionTypes.GET_REVIEW_LOCATION_LIST;
        const key = isListView ? 'reviewInvoiceList' : 'reviewLocationList';
        const fallback = isListView
            ? { reviewedInvoices: [], location: '', allReviewLocations: [] }
            : { location: '', reviewedInvoicesCount: 0 };

        try {
            const response = await getAxiosInstance(moduleTypes.MANAGE).get(url);
            if (response.status === 200) {
                dispatch({ type, [key]: response.data.response });
            } else {
                dispatch({ type, [key]: fallback });
            }
        } catch (error) {
            dispatch({ type, [key]: fallback });
        }
    };
};
